export default {
  path: "/delivery",
  component: () => import("./index.vue"),
  name: "delivery",
  meta: {
    title: "delivery.title"
  }
}
